<template>
    <!-- :disabled="readonly || config.readonly" -->
    <!-- <el-date-picker class="X-Date" v-model="config.date" type="date"  :placeholder="config.placeholder" :size="config.size" /> -->
    <div class="x-date-range">
        <el-date-picker :type="getType(config?.type)" :modelValue="start"
            @update:modelValue="(value, oldvalue) => { start = value; $emit('update:modelValue', getModelValue(), modelValue) }"
            :disabled="readonly || config?.readonly" :format="getFormat(config?.format, config?.type)"
            :value-format="getFormat(config?.format, config?.type)" :disabled-date="startDisabledDate"
            style="width:46%;float: left;"></el-date-picker>

        <div style="width: 8%;;text-align: center;float: left;">到</div>
        <el-date-picker :type="getType(config?.type)" :modelValue="end"
            @update:modelValue="(value, oldvalue) => { end = value; $emit('update:modelValue', getModelValue(), modelValue) }"
            :disabled="readonly || config?.readonly" :format="getFormat(config?.format, config?.type)"
            :value-format="getFormat(config?.format, config?.type)" :disabled-date="endDisabledDate" style="width:46%"></el-date-picker>
    </div>
</template>
<script setup>
import { defineProps, ref, watch, computed } from 'vue';
import FieldType from '../../datamodule/FieldType';

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})
defineEmits({
    "update:modelValue": null,
});

const start = ref(null);
const end = ref(null);
watch(() => props.modelValue, (value) => {
    start.value = getStart(value);
    end.value = getEnd(value);
})
const getModelValue = () => {
    return [start.value, end.value];
}

const getStart = (value) => {
    return value ? value[0] : null;
}
const getEnd = (value) => {
    return value ? value[1] : null;
}

const getType = (type) => {
    switch (type) {
        default:
        case FieldType.DATERANGE: return 'date';
        case FieldType.DATETIMERANGE: return 'datetime';
    }
}

const getFormat = (format, type) => {
    if (format) return format;
    switch (type) {
        default:
        case FieldType.DATERANGE: return 'YYYY-MM-DD';
        case FieldType.DATETIMERANGE: return 'YYYY-MM-DD HH:mm:ss';
    }
}
const startDisabledDate = computed(() => {
    return (value) => {
       if(end.value) return value.getTime()>(new Date(end.value)).getTime()
    }
})
const endDisabledDate = computed(() => {
    return (value) => {
       if(start.value) return value.getTime()<(new Date(start.value)).getTime()
    }
})
</script>
<style>
.x-date-range {
    width: 100%;
}
</style>